// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import { Dropzone } from "dropzone";

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("@rails/actiontext")
require("trix")
require("channels")
require('jquery')
require('jquery-ui')
require("dropzone");
require("@fullcalendar/core")
require("@fullcalendar/daygrid")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


global.Dropzone = Dropzone;
global.Rails = Rails;
global.$ = jQuery;
global.jQuery = jQuery;
global.fullCalendar = fullCalendar; 

document.addEventListener('ajax:success', function(event) {
  const [data] = event.detail;
  if (data.flash_message) {
    // Aquí puedes usar la librería que tengas para mostrar alertas,
    // o un alert simple para empezar:
    alert(data.flash_message);
  }
  if (data.redirect_url) {
    window.location.href = data.redirect_url;
  }
});